export default __webpack_public_path__ + "static/bingham-dd0ff81bd63d5d1682304b5100cb61f6.png";